import React from 'react';
import ContactSelect from './Selectors/ContactSelect';
import { getChosenContact } from '../../../Helpers/invoiceAutomationEditorHelper';

// The bill-to contact of an invoice (InputTypesEnum.InvoiceBillToContactSelect): the client's active contacts that
// have an address, as for a new invoice, and under the choice the tax number, bill-to name and office the chosen contact
// brings, read only. They are read from the client's contacts the edited item carries (ClientContacts), as on the
// invoice form. onChange gets the field's name and the chosen contact's id, as a select's does.
export default function InvoiceBillToContactSelect({
  value = null,
  className = 'w-100 form-control form-control-sm',
  fieldName = '',
  onChange = (changedFieldName, newValue) => {},
  filterCleared = false,
  idFilter = null,
  editedItem = null,
}) {
  const chosenContact = getChosenContact({ ...(editedItem ?? {}), ContactId: value });

  return (
    <div className='w-100'>
      <ContactSelect
        value={value}
        className={className}
        fieldName={fieldName}
        onChange={onChange}
        filterCleared={filterCleared}
        idFilter={idFilter}
        onlyActive={true}
        onlyWithAddress={true}
      />
      {chosenContact && (
        <dl className='iauto-contact-details'>
          <dt>Bill To Client Tax #</dt>
          <dd>{chosenContact.vatnumber || 'Not set'}</dd>
          <dt>Bill To Client Name</dt>
          <dd>{chosenContact.billToClientName || 'Not set'}</dd>
          <dt>Office</dt>
          <dd>{chosenContact.officeName || 'Not set'}</dd>
        </dl>
      )}
    </div>
  );
}
